import {useEvent} from 'Event/EventProvider'
import {useObieHubs} from 'lib/event-api/integrations/obie/hubs/list'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'

export interface HubSelectProps {
  value: string | null
  onChange: (obieHubId: string) => void
  disabled?: boolean
}

export default function HubSelect(props: HubSelectProps) {
  const {value, onChange, disabled} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const {data: hubs = [], isLoading, error} = useObieHubs({client, event})

  if (isLoading) {
    return (
      <Select
        label="AI Hub"
        aria-label="ai hub"
        helperText="Attendees are sent to this AI Hub."
        value=""
        onChange={() => {}}
        displayEmpty
        disabled
        fullWidth
      >
        <Option value="">Loading…</Option>
      </Select>
    )
  }

  if (error) {
    return (
      <Select
        label="AI Hub"
        aria-label="ai hub"
        helperText={error.message}
        error
        value=""
        onChange={() => {}}
        disabled
        fullWidth
      />
    )
  }

  if (hubs.length === 0) {
    return (
      <Select
        label="AI Hub"
        aria-label="ai hub"
        helperText="Attendees are sent to this AI Hub."
        value=""
        onChange={() => {}}
        displayEmpty
        disabled
        fullWidth
      >
        <Option value="">
          No AI Hubs found. Create one in Obie, then reload this page.
        </Option>
      </Select>
    )
  }

  const isSavedHubMissing =
    Boolean(value) && !hubs.some((hub) => hub.id === value)

  return (
    <Select
      label="AI Hub"
      aria-label="ai hub"
      helperText="Attendees are sent to this AI Hub."
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value as string)}
      disabled={disabled}
      fullWidth
    >
      {isSavedHubMissing && (
        <Option value={value} disabled>
          Not found in Obie
        </Option>
      )}
      {hubs.map((hub) => (
        <Option key={hub.id} value={hub.id}>
          {hub.name}
        </Option>
      ))}
    </Select>
  )
}
